<template>
  <div class="flex flex-col">
    <h2>Planes</h2>

    <div class="flex flex-col lg:flex-row gap-4 lg:gap-6 mt-6 items-start">
      <status-side-nav :options="statusNavOptions" />

      <div class="flex-1 min-w-0 w-full">

    <div class="flex flex-col">
      <custom-search
        class="mt-6 w-full sm:w-[500px]"
        placeholder="Buscar por No. de Plan, Cliente ó Mascota"
        v-model="searchText"
        @confirm="search"
        @clear="search"
      />

      <div class="card mt-6">
        <table class="table-auto text-sm mt-2 bg-white">
          <thead class="text-left">
            <tr class="bg-primary-100">
              <th class="px-4 py-3 rounded-l-lg text-xs font-semibold text-primary-700 uppercase tracking-wide">ID</th>
              <th class="px-4 py-3 text-xs font-semibold text-primary-700 uppercase tracking-wide">Cliente</th>
              <th class="px-4 py-3 text-xs font-semibold text-primary-700 uppercase tracking-wide">Mascotas</th>
              <th class="px-4 py-3 text-xs font-semibold text-primary-700 uppercase tracking-wide">Fecha de creación</th>
              <th class="px-4 py-3 rounded-r-lg text-xs font-semibold text-primary-700 uppercase tracking-wide">Acciones</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="quote in quotes" :key="quote.id" class="table-row">
              <td class="table-cell">
                {{ quote.id }}
              </td>
              <td class="table-cell">
                <div>
                  <router-link
                    v-if="quote.client"
                    :to="{
                      name: 'clientsDetail',
                      params: { id: quote.client.id },
                    }"
                    class="underline system-button"
                    >{{ quote.client.name }}
                    {{ quote.client.last_name }}</router-link
                  >
                  <span v-else class="text-content-300">—</span>
                </div>
              </td>
              <td class="table-cell">
                <div class="flex flex-wrap">
                  <div v-for="diet in quote.diets" :key="diet.id" class="mr-4">
                    <router-link
                      v-if="diet.pet"
                      :to="{
                        name: 'petsDetail',
                        params: { id: diet.pet.id },
                      }"
                      class="underline system-button"
                      >{{ diet.pet.name }}</router-link
                    >
                    <span v-else class="text-content-300"
                      >Mascota eliminada</span
                    >
                  </div>
                </div>
              </td>
              <td class="table-cell">
                {{ formatDatetime(quote.created_at) }}
              </td>
              <td class="table-cell">
                <div class="flex space-x-1">
                  <router-link
                    :to="{
                      name: 'quotesDetail',
                      params: { id: quote.id },
                    }"
                    class="secondary-button"
                    >Detalle</router-link
                  >
                </div>
              </td>
            </tr>
          </tbody>
        </table>

        <div v-if="loading" class="flex w-full h-full items-center">
          <loader-icon class="h-10 w-10 text-primary-500 mx-auto"></loader-icon>
        </div>
      </div>
    </div>

    <pagination
      :current-page="currentPage"
      :total-pages="totalPages"
      @page-change="onPageChange"
    />
      </div>
    </div>
  </div>
</template>

<script>
import api from "@/api";
import Pagination from "@/components/ui/Pagination.vue";
import StatusSideNav from "@/components/ui/StatusSideNav";
import { formatDatetime } from "@/utils/dateFormatter";
import { integerToCurrency } from "@/utils/currencyFormatter";
export default {
  name: "Quotes",

  components: {
    Pagination,
    StatusSideNav,
  },

  computed: {
    statusNavOptions() {
      return [
        { status: "pending", label: "Pendientes de pago", icon: "🕐", activeClass: "text-tertiary-500" },
        { status: "active", label: "Activos", icon: "✅", activeClass: "text-success-500" },
        { status: "paused", label: "Pausados", icon: "⏸️", activeClass: "text-error-300" },
        { status: "canceled", label: "Cancelados", icon: "❌", activeClass: "text-error-500" },
        { status: "suspended", label: "Suspendidos", icon: "⚠️", activeClass: "text-error-600" },
      ].map((option) => ({
        label: option.label,
        icon: option.icon,
        to: { name: "quotesIndex", query: { status: option.status } },
        active: this.$route.query.status === option.status,
        activeClass: option.activeClass,
      }));
    },
  },

  data() {
    return {
      quotes: null,
      loading: false,
      status: null,
      // Prefill desde ?search= (permite deep-links desde notificaciones que
      // referencian planes por número). Inicializado en data() para que el
      // watcher immediate de status ya lo vea en la primera carga.
      searchText: this.$route.query.search || "",
      currentPage: 1,
      totalPages: 0,
    };
  },

  created() {
    this.$store.commit("setSelectedTab", "quotes");

    this.status = this.$route.query.status;
    if (!this.status) {
      this.$router.push({
        name: "quotesIndex",
        query: { status: "pending" },
      });
    }

    // this.loadQuotes();
  },

  methods: {
    formatDatetime,

    integerToCurrency,

    async loadQuotes() {
      this.loading = true;

      try {
        const response = await api.quotes.getAllWithQueryParams([
          { name: "status", value: this.status },
          {
            name: "page",
            value: this.currentPage,
          },
          {
            name: "search",
            value: this.searchText,
          },
        ]);
        this.quotes = response.data;
        this.currentPage = response.current_page;
        this.totalPages = response.last_page;
      } catch (error) {
        this.$store.dispatch("errorSnack", error?.response?.data?.message);
      }

      this.loading = false;
    },

    search() {
      this.currentPage = 1;
      this.loadQuotes();
    },

    onPageChange(page) {
      this.currentPage = page;
      this.loadQuotes();
    },
  },

  watch: {
    "$route.query.status": {
      immediate: true,
      handler(newStatus) {
        this.status = newStatus || "pending";
        this.loadQuotes();
      },
    },
  },
};
</script>